import React, { Component } from 'react';
import trans from '../../translations.json';

import Header from '../LTC/ltcHeader';
import SectionHeader from '../SectionHeader';
import Tabs from '../tabs/tabs';

import Infographic from '../Infographic';

import LTCActiveCases from '../LTC/ltcActiveCases.jsx';
import LTCActiveCasesTable from '../LTC/ltcActiveCases-Table.jsx';

import LTCTotalDeaths from '../LTC/ltcTotalDeaths';
import LTCTotalDeathsTable from '../LTC/ltcTotalDeaths-Table';

import LTCDeaths from '../LTC/ltcDailyDeaths';
import LTCDailyDeathsTable from '../LTC/ltcDailyDeaths-Table';

import LtcMapIndex from '../LTC/LtcMap/LtcMapIndex';
//import LtcByPHUIndex from '../LTC/LtcByPHU/LtcByPHUIndex';

class Ltc2 extends Component {
  render() {
    const lang = this.props.lang,
      momentBuildTime = this.props.momentBuildTime;
    // console.log(totalSince);
    return (
      <>
        <Header lang={lang} lastUpdated={momentBuildTime} />
        <SectionHeader
          id="casestatus"
          title={trans.otp.byNumbers2}
          lastUpdated={momentBuildTime}
          lang={lang}
        />
        <div className="ontario-row">
          <Infographic
            id=""
            lang={lang}
            defaultSelection="chart"
            width="full"
            titleDesc={{
              title: trans.LtcMap.title,
            }}
            opts={['chart']}
            chart={<LtcMapIndex lang={lang} />}
          />
          {/*<Infographic
            id=""
            lang={lang}
            defaultSelection="chart"
            width="full"
            titleDesc={trans.phu}
            desc={trans.phu.desc}
            opts={['chart']}
            chart={
              <LtcByPHUIndex
                lang={this.props.lang}
                selectedTab="newCases"
              />
            }
          />*/}
          <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
            {/* <h3>{trans.casesDaily.title[lang]}</h3>
            <Tabs
              lang={lang}
              newCases={
                <Infographic
                  id="CasesDaily"
                  lang={lang}
                  //titleDesc={trans.casesDaily}
                  bar={
                    <LTCDailyCases
                      lang={lang}
                      chartTitle={trans.casesDaily.title[lang]}
                    />
                  }
                  table={<LTCDailyCasesTable lang={lang} />}
                  width="default"
                />
              }
              totalCases={
                <Infographic
                  id="CasesTotal"
                  lang={lang}
                  // titleDesc={trans.casesTotal}
                  bar={
                    <LTCTotalCases
                      lang={lang}
                      chartTitle={trans.casesTotal.title[lang]}
                    />
                  }
                  table={<LTCTotalCasesTable lang={lang} />}
                  width="default"
                />
              }
            /> */}
            <h3>{trans.viewModes.active[lang]}</h3>
            <Infographic
              id="ActiveCases"
              lang={lang}
              bar={
                <LTCActiveCases
                  chartTitle={trans.casesTotal.title[this.props.lang]}
                  lang={lang}
                />
              }
              table={<LTCActiveCasesTable lang={lang} />}
              width="default"
            />

            <h3>{trans.reg.deaths[lang]}</h3>
            <Tabs
              lang={lang}
              newCases={
                <Infographic
                  id="Deaths"
                  lang={lang}
                  bar={
                    <LTCDeaths
                      lang={lang}
                      chartTitle={trans.deathsDaily.deaths[lang]}
                    />
                  }
                  table={<LTCDailyDeathsTable lang={lang} />}
                  width="default"
                />
              }
              totalCases={
                <Infographic
                  id="Deaths"
                  lang={lang}
                  bar={
                    <LTCTotalDeaths
                      lang={lang}
                      chartTitle={trans.overview.deaths[lang]}
                    />
                  }
                  table={<LTCTotalDeathsTable lang={lang} />}
                  width="default"
                />
              }
            />
          </div>
        </div>
      </>
    );
  }
}

export default Ltc2;
